import { Directive, ElementRef, Renderer2, Input, OnInit, HostBinding } from '@angular/core';

@Directive({
	selector: '[kpaKendoButton]',
	exportAs: 'kpaKendoButton',
})
export class KpaKendoButtonDirective implements OnInit {
	@Input() kpaKendoButton: 'primary' | 'secondary' = 'primary';

	constructor(
		private el: ElementRef,
		private renderer: Renderer2
	) {}

	ngOnInit() {
		this.applyButtonStyle();
	}

	private applyButtonStyle() {
		let buttonClass = this.kpaKendoButton === 'primary' ? 'primary-button' : 'secondary-button';
		this.renderer.addClass(this.el.nativeElement, buttonClass);
	}
}
